<template>
  <b-modal ref="modal" :title="$t('vizualization')" @ok="okClicked">
    <b-form-group
      id="spaceplan-name-group"
      :label="$t('vizualization-name')"
      label-for="spaceplan-name"
    >
      <b-form-input
        id="spaceplan-name"
        v-model="form.name"
        type="text"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group
      id="spaceplan-image-group"
      :label="$t('vizualization-file')"
      label-for="spaceplan-image"
    >
      <b-form-file
        id="spaceplan-image"
        v-model="form.image"
        :state="Boolean(form.image)"
        :placeholder="$t('choose-a-file')"
        :drop-placeholder="$t('drop-file-here')"
        accept="image/*"
      ></b-form-file>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SpacePlanModalForm',
  data() {
    return {
      form: {
        name: '',
        image: null,
      },
    };
  },
  methods: {
    ...mapActions([
      'addSpaceplan',
    ]),
    okClicked() {
      const formData = new FormData();
      formData.append('image', this.form.image);
      formData.append('name', this.form.name);
      this.addSpaceplan(formData);
      this.form.name = '';
      this.form.image = null;
    },
    initData({ name }) {
      this.form.name = name;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style scoped>

</style>
